import React, {useEffect, useState} from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import SwiperCore, {Navigation, Pagination, Scrollbar, A11y, Autoplay, EffectFade} from 'swiper';
import slider from "../../res/img/head.png"
import 'swiper/swiper.min.css';
import ProfessorBox from "../professorBox/professorBox";
import "./slider.css"
import {ENV} from "../../services/env";
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay, EffectFade]);

const Slider = (props) => {
    let lg = 1
    let md = 1
    let sm = 1
    let xs = 1
    const params = {
        spaceBetween: 30,
        slidesPerGroup: 1,
        loop: true,
        pagination: {
            el: '.swiper-pagination',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            disabledClass: '.swiper-button-disabled',
            hideOnClick: true,
            lockClass: 'swiper-button-lock',
        },

        autoplay: {
            delay:4000,
            disableOnInteraction: false,
            reverseDirection: true,
        },
        breakpoints: {
            1024: {
                slidesPerView: lg,
                spaceBetween: 30
            },
            768: {
                slidesPerView: md,
                spaceBetween: 30
            },
            640: {
                slidesPerView: sm,
                spaceBetween: 20
            },
            320: {
                slidesPerView: xs,
                spaceBetween: 10
            }
        }
    }
    return (
        <div className={"slider"}>
            {
                props.type === "professor" &&
                <Swiper  {...params} navigation>
                    {
                        props && props.list.list && props.list.list.map((item) =>{
                            return (
                                <SwiperSlide>
                                    <ProfessorBox title={item.title} des={item.description} image={item.image}/>
                                </SwiperSlide>
                            )
                        })
                    }
                </Swiper>
            }
            {
                props.type === "main" &&
                <Swiper  {...params} navigation>
                    {
                        props && props.list.list && props.list.list.map((item) =>{
                            return (
                                <SwiperSlide>
                                    <div className={"main-slider"}>
                                        <img alt={item.title} src={ENV.API.IMG + item.image}/>
                                    </div>
                                </SwiperSlide>
                            )
                        })
                    }
                </Swiper>
            }

        </div>
    );
};

export default Slider;
